import { useState } from "react";
import { Helmet } from "react-helmet";
import { html as html_beautify } from "js-beautify";
import BackButton from "../components/BackButton";

export default function HtmlFormatter() {
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");

  const formatHTML = () => {
    try {
      const formatted = html_beautify(input, {
        indent_size: 2,
        wrap_line_length: 80,
        unformatted: [], // don't leave any tag unformatted
      });
      setOutput(formatted);
      setError("");
    } catch (err) {
      setError("Error formatting HTML: " + err.message);
      setOutput("");
    }
  };

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    alert("Formatted HTML copied!");
  };

  return (
    <>
        <Helmet>
          <title>HTML Formatter Online - Free Tool to Beautify & Format Code</title>
          <meta
            name="description"
            content="Beautify and format your HTML code online. Improve indentation, make your code more readable, and copy it with one click. 100% free HTML formatter tool."
          />
          <meta name="keywords" content="html formatter, online html beautifier, format html code, beautify html, html code cleaner, free html tool" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://freelity.com/html-formatter" />
        </Helmet>


        <section className="sec-free-tools">
            <div className="container">
                <BackButton />
                <h2>HTML Formatter & Beautifier</h2>

                <textarea
                rows="10"
                className="form-control mb-3"
                placeholder="Paste your HTML here..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                />

                <button className="btn btn-primary mb-3" onClick={formatHTML}>
                Format HTML
                </button>

                {error && <div className="alert alert-danger">{error}</div>}

                {output && (
                <>
                    <textarea
                    rows="10"
                    className="form-control mb-3"
                    value={output}
                    readOnly
                    />
                    <button className="btn btn-success bigsize" onClick={copyOutput}>
                      Copy Formatted HTML
                    </button>
                </>
                )}
            </div>
        </section>
    </>
  );
}
